import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import Toast from '@/shared/services/toast';
import { maxLength, required, requiredIf, numeric } from '@vuelidate/validators';
import { GovNotifyServiceViewModel } from '../models/govNotifyServiceViewModel';
import { govNotifyApi } from '../services/govNotifyApi';
import { computed, PropType, ref, watch } from 'vue';
import useVuelidate from '@vuelidate/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';
import NSplitInputButton from '@shared/designsystem/components/input/split-input-button/split-input-button.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GovNotifyServiceConfigurationRow',
  props: {
  modelValue: {
    type: Object as PropType<Partial<GovNotifyServiceViewModel>>,
    required: true,
  },
  loadingTemplates: {
    type: Boolean,
    default: false,
  },
  workspaceId: {
    type: String,
    required: true,
  },
  column: {
    type: String as PropType<'name' | 'phoneNumber' | 'notifyApiKey' | 'templateName' | 'bearerToken' | 'actions'>,
    required: true,
  },
},
  emits: ["update:modelValue", "update:loadingTemplates", "delete", "copy"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const model = ref(props.modelValue);

const validations = {
  name: { required },
  name: { required },
  phoneNumber: {
    required: requiredIf(() => !!model.value.isDraft),
    numeric: numeric,
    maxLength: maxLength(15),
  },
  notifyApiKey: {
    required: requiredIf(() => !!model.value.isDraft),
  },
  selectedTemplate: {
    required: requiredIf(() => !!model.value.isDraft),
  },
};

const $v = useVuelidate(validations, model.value);

async function loadTemplates() {
  if (model.value.notifyApiKey === '') {
    return;
  }
  emit('update:loadingTemplates', true);
  try {
    const response = await govNotifyApi.getTemplates(props.workspaceId, model.value.notifyApiKey);
    model.value.templates = response.templates;
    model.value.selectedTemplate = response.templates[0] || { id: '', name: 'No templates configured', body: '' };
  } catch (err: any) {
    Toast.showError(err.message);
  }
  emit('update:loadingTemplates', false);
}

const getTemplateOptions = computed(() => {
  if (!model.value.templates) {
    model.value.selectedTemplate = { id: '', name: 'No templates configured', body: '' };
    return [model.value.selectedTemplate];
  }
  return model.value.templates;
});

const canLoadTemplates = computed(() => {
  return !props.loadingTemplates && model.value.notifyApiKey.length > 0;
});

watch(
  () => model.value.name,
  () => {
    $v.value.name.$touch();
    emit('update:modelValue', model.value);
  },
);
watch(
  () => model.value.phoneNumber,
  () => {
    $v.value.phoneNumber.$touch();
    emit('update:modelValue', model.value);
  },
);
watch(
  () => model.value.notifyApiKey,
  () => {
    $v.value.notifyApiKey.$touch();
    emit('update:modelValue', model.value);
  },
);
watch(
  () => model.value.selectedTemplate,
  () => {
    $v.value.selectedTemplate.$touch();
    emit('update:modelValue', model.value);
  },
  { immediate: true },
);

function getErrorMessage(field: string, label: string) {
  return VuelidateUtil.getErrorMessage($v, field, label);
}

function onCopy() {
  emit('copy');
  Toast.showInfo('Copied to clipboard');
}

function handleDeleteClick() {
  emit('delete', model.value);
}

return (_ctx: any,_cache: any) => {
  const _component_n_text_input = _resolveComponent("n-text-input")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_readonly_input = _resolveComponent("n-readonly-input")!

  return (__props.column === 'name')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!model.value.isDraft)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(model.value.name), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_n_text_input, {
                modelValue: model.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.name) = $event)),
                hideLabel: true,
                label: "Service Name",
                errorMessage: getErrorMessage('name', 'Service Name')
              }, null, 8, ["modelValue", "errorMessage"])
            ]))
      ], 64))
    : (__props.column === 'phoneNumber')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!model.value.isDraft)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(model.value.phoneNumber), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_n_text_input, {
                  modelValue: model.value.phoneNumber,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.phoneNumber) = $event)),
                  hideLabel: true,
                  label: "Phone Number",
                  errorMessage: getErrorMessage('phoneNumber', 'Phone Number')
                }, null, 8, ["modelValue", "errorMessage"])
              ]))
        ], 64))
      : (__props.column === 'notifyApiKey')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (!model.value.isDraft)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*****"))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_n_text_input, {
                    modelValue: model.value.notifyApiKey,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.notifyApiKey) = $event)),
                    hideLabel: true,
                    label: "API Key",
                    onChange: loadTemplates,
                    errorMessage: getErrorMessage('notifyApiKey', 'API Key')
                  }, null, 8, ["modelValue", "errorMessage"])
                ]))
          ], 64))
        : (__props.column === 'templateName')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (!model.value.isDraft)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(model.value.templateName), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(NSplitInputButton, {
                      hideLabel: true,
                      label: "Template Name",
                      id: `templateName-${model.value.id}`
                    }, {
                      input: _withCtx(() => [
                        _createVNode(_component_n_select, {
                          id: `templateName-${model.value.id}`,
                          modelValue: model.value.selectedTemplate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.selectedTemplate) = $event)),
                          options: getTemplateOptions.value,
                          "value-prop": "id",
                          "label-prop": "name",
                          hideLabel: true,
                          disabled: !canLoadTemplates.value,
                          errorMessage: getErrorMessage('selectedTemplate', 'Template')
                        }, null, 8, ["id", "modelValue", "options", "disabled", "errorMessage"])
                      ]),
                      button: _withCtx(() => [
                        _createVNode(_component_n_button, {
                          icon: "refresh",
                          variant: "split",
                          disabled: !canLoadTemplates.value,
                          onClick: loadTemplates
                        }, null, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["id"])
                  ]))
            ], 64))
          : (__props.column === 'bearerToken')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (!model.value.isDraft)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*****"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_n_readonly_input, {
                        value: model.value.bearerToken,
                        label: "Bearer Token",
                        onCopy: onCopy,
                        hideLabel: true
                      }, null, 8, ["value"])
                    ]))
              ], 64))
            : (__props.column === 'actions')
              ? (_openBlock(), _createBlock(_component_n_button, {
                  key: 5,
                  variant: "action",
                  icon: "delete",
                  onClick: handleDeleteClick
                }))
              : _createCommentVNode("", true)
}
}

})